// src/api/securityQuestionApi.js
import apiClient from './axios';

const securityQuestionApi = {
  /** GET /api/questions/ */
  getAll: async () => {
    const response = await apiClient.get('/questions/', {
      headers: { Authorization: '' }, // public
    });
    return response.data || [];
  },

  /** POST /api/password-reset/verify/ */
  verify: async (employeeCode, answers) => {
    const payload = {
      code: employeeCode,
      answers: answers.map(([question_id, answer]) => ({ question: question_id, answer })),
    };

    const response = await apiClient.post('/password-reset/verify/', payload, {
      headers: { Authorization: '' }, // public
    });

    return response.data;
  },


  /** POST /api/first-login/ – first-time setup */
  firstLoginSetup: async (answers) => {
    const payload = {
      answers: answers.map(([question, answer]) => ({ question, answer })),
    };

    const r = await apiClient.patch('/first-login/', payload);
    return r.data;
  },
};

export default securityQuestionApi;